<mat-card class="__card  z-manual-elevation  c-soft-elevation">
  <h4 class="__title">
    @if (hasMultipleErrors()) {
      Oof, couple things went wrong …
    } @else if (processedErrors().length) {
      {{ firstErrorMessage() }}
    }
  </h4>

  <div class="__content">
    @for (processedError of processedErrors(); track $index) {
      @if (processedError.meta?.length) {
        @for (meta of processedError.meta; track $index) {
          @if (processedError.hasMultipleMeta) {
            <h5>— {{ meta.error }}</h5>
          }
          @if (!!meta.metadata) {
            <pre class="__meta-info"><code>{{ meta.metadata | json }}</code></pre>
          }
        }
      }
    }
  </div>

  <button
    mat-button
    class="__button  c-button--full"
    (click)="instance.close()">
    <mat-icon class="__button_icon">report</mat-icon> Okay, close.
  </button>

</mat-card>
